// https://meta.feishu.cn/wiki/HMq7wgdatiBPq6kX750cj7tznKc

interface ConfigResult {
  startMode: "233-HTTP" | "233-FILE" | "GPARK-HTTP" | "GPARK-FILE";
  env: "TEST" | "PRE" | "PROD";
  mode: "development" | "production";
  usualServerUrl: string;
  // 233或者gpark通过env文件配置的baseUrl
  baseUrl: string;
  // ai 这边的接口域名
  aiUrl: string;
  // 联运环境访问时的基础域名
  combineUrl: string;
  // 派对应用的基础域名
  partyBaseUrl: string;
  // pandora 相关
  pandoraIndexType: string;
  pandoraSelfpackagename: string;
  pandoraAppkey: string;
  pandoraBaseUrl: string;
  pandoraZone: string;
  websiteBaseUrl: string;
  partyPolicyBaseUrl: string;
  lylyPolicyBaseUrl: string;
  // pandora - 233派对ios
  pandoraSelfpackagenameIOS: string;
  pandoraAppkeyIOS: string;
}

/**
 * 查看配置信息
 */
export function useConfig(): ConfigResult {
  return {
    startMode: import.meta.env.VITE_START_MODE,
    env: import.meta.env.VITE_ENV,
    mode: import.meta.env.MODE,
    usualServerUrl: import.meta.env.VITE_USUAL_SERVER_URL,
    baseUrl: import.meta.env.VITE_BASE_URL,
    aiUrl: import.meta.env.VITE_AI_URL,
    combineUrl: import.meta.env.VITE_COMBINE_URL,
    partyBaseUrl: import.meta.env.VITE_PARTY_BASE_URL,
    // pandora
    pandoraIndexType: import.meta.env.VITE_pandora_index_type,
    pandoraSelfpackagename: import.meta.env.VITE_pandora_selfpackagename,
    pandoraAppkey: import.meta.env.VITE_pandora_appkey,
    pandoraBaseUrl: import.meta.env.VITE_pandora_baseUrl,
    pandoraZone: import.meta.env.VITE_pandora_baseUrl,
    // pandora - 233派对ios
    pandoraSelfpackagenameIOS: import.meta.env.VITE_PANDORA_SELFPACKAGENAME_IOS,
    pandoraAppkeyIOS: import.meta.env.VITE_PANDORA_SELFPACKAGENAME_IOS,

    appId:'30001',
    // web 网站
    websiteBaseUrl: import.meta.env.VITE_website_baseUrl,
    // 协议baseurl
    partyPolicyBaseUrl: import.meta.env.VITE_PARTY_POLICY_BASEURL,
    lylyPolicyBaseUrl: import.meta.env.VITE_LYLY_POLICY_BASEURL,
    crsVersion: import.meta.env.VITE_CRS_VERSION
  } as unknown as ConfigResult;
}
